import React from "react";
import moment from "moment";
import {Button} from "reactstrap";
import {confirmAlert} from "react-confirm-alert";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import {membershipBillingAlertDetails} from "utils/membershipBilling";

const toastOptions = {
	position: API.Toast.POSITION && API.Toast.POSITION.TOP_CENTER ? API.Toast.POSITION.TOP_CENTER : "top-center",
};

const membershipCustomerName = (membership) => (
	membership && membership.paying_customer && membership.paying_customer.name
	|| membership && membership.customers && membership.customers.name
	|| "this customer"
);

const formatDate = (value, includeTime = false) => {
	const date = value ? moment(value) : null;
	if (!date || !date.isValid()) {
		return "Not available";
	}

	return date.format(includeTime ? "MM/DD/YYYY h:mm A" : "MM/DD/YYYY");
};

export default class MembershipBillingAlert extends React.Component {
	state = {
		cancelling: false,
	};

	cancelMembership = () => {
		const membership = this.props.membership || {};
		const membershipName = membership.name || membership.level_tier || "Membership";
		const customerName = membershipCustomerName(membership);
		const coveredMemberCount = parseInt(membership.covered_member_count, 10) || 0;
		const coveredMemberWarning = coveredMemberCount > 0
			? ` This will also end access for ${coveredMemberCount} covered member${coveredMemberCount === 1 ? "" : "s"}.`
			: "";

		confirmAlert({
			title: "Cancel Membership Immediately?",
			message: `Cancel ${customerName}'s "${membershipName}" membership now? Future billing retries and membership benefits will stop.${coveredMemberWarning}`,
			buttons: [
				{
					label: "Cancel Membership Now",
					onClick: this.submitCancellation,
				},
				{
					label: "Keep Membership",
					onClick: () => {},
				},
			],
		});
	};

	submitCancellation = async () => {
		const membership = this.props.membership || {};
		const membershipPkey = parseInt(membership.pkey, 10);
		if (!Number.isFinite(membershipPkey) || membershipPkey <= 0 || this.state.cancelling) {
			return;
		}

		this.setState({cancelling: true});
		try {
			const requestType = "POST_CANCEL";
			const requestModel = new API.BuildClass(Types.Memberships._name, requestType);
			requestModel.object = {membership_action: membershipPkey};
			const response = await requestModel.submit(null, requestType, true);
			API.Toast.success("Membership cancelled. Future billing retries and benefits have stopped.", toastOptions);
			if (typeof this.props.onCancelled === "function") {
				await this.props.onCancelled(response && response.membership ? response.membership : membership);
			}
		} catch (error) {
			API.Toast.error(error.message || "Unable to cancel this membership.", toastOptions);
		}
		this.setState({cancelling: false});
	};

	render() {
		const membership = this.props.membership || {};
		const details = membershipBillingAlertDetails(membership);
		if (!details.show) {
			return null;
		}
		if (details.alertType === "cancelled") {
			return (
				<div className="membership-billing-alert membership-cancelled-alert" role="alert">
					<div className="membership-billing-alert-heading">
						<i className="fa fa-ban" aria-hidden="true"/>
						<strong>Membership Cancelled</strong>
					</div>
					<div className="membership-cancelled-alert-message">
						<strong>Cancelled:</strong> {formatDate(details.cancelledAt, true)}
						<span>Membership access and benefits are inactive. No more billing attempts are scheduled.</span>
					</div>
				</div>
			);
		}

		return (
			<div className="membership-billing-alert" role="alert">
				<div className="membership-billing-alert-heading">
					<i className="fa fa-exclamation-triangle" aria-hidden="true"/>
					<strong>Membership Billing Failed</strong>
				</div>
				<div className="membership-billing-alert-details">
					<span><strong>Failed attempts:</strong> {details.failedAttempts} of {details.maxAttempts}</span>
					<span><strong>Last failed bill:</strong> {formatDate(details.lastFailedBillingAt, true)}</span>
					<span><strong>Next billing attempt:</strong> {formatDate(details.nextBillingAttemptAt)}</span>
					<span><strong>Attempts remaining:</strong> {details.remainingAttempts}</span>
				</div>
				<Button
					className="membership-billing-alert-cancel"
					color="danger"
					disabled={this.state.cancelling}
					onClick={this.cancelMembership}
					type="button"
				>
					{this.state.cancelling ? "Cancelling..." : "Cancel Membership Now"}
				</Button>
			</div>
		);
	}
}
